import { Cardy, type CardyProps } from "@stenajs-webui/elements";

import styles from "./CompactCard.module.css";

export interface CompactCardProps extends CardyProps {}

export function CompactCard(props: CompactCardProps) {
  return <Cardy {...props} className={styles.compactCard} />;
}
